// extracted by mini-css-extract-plugin
export var heading = "TicketThreeUpSection-module--heading--3PZV-";
export var mainContainer = "TicketThreeUpSection-module--mainContainer--3DTyk";
export var CardsContainer = "TicketThreeUpSection-module--CardsContainer--3yqbd";
export var singleCard = "TicketThreeUpSection-module--singleCard--3s-wF";
export var mostPopularCardDesign = "TicketThreeUpSection-module--mostPopularCardDesign--Zz-9W";
export var middleCardDesign = "TicketThreeUpSection-module--middleCardDesign--G7mu0";
export var lastCardDesign = "TicketThreeUpSection-module--lastCardDesign--2SNTl";
export var mostPopular = "TicketThreeUpSection-module--mostPopular--18pbm";
export var cardContentWrapper = "TicketThreeUpSection-module--cardContentWrapper--3syEM";
export var CardTitle = "TicketThreeUpSection-module--CardTitle--1fAWX";
export var pricing = "TicketThreeUpSection-module--pricing--1jl7R";
export var cardInfo = "TicketThreeUpSection-module--cardInfo--3Pu21";
export var purchaseButton = "TicketThreeUpSection-module--purchaseButton--1LABw";
export var linkContainer = "TicketThreeUpSection-module--linkContainer--23WYg";
export var freeCta = "TicketThreeUpSection-module--free-cta--JSr_q";